import React from 'react';
import '../../../../styles/BathingDates.css';
import PropTypes from 'prop-types';

const BathingDates = ({ data, heading, customClass = '' }) => {
  return (
    <div className={`rlBthDate ${customClass ? customClass : ''}`}>
      {heading && <h4 className="blackText">{heading}</h4>}
      {data && data.length > 0 && (
        <ul className="rlBthDate__list">
          {data.map(({ id, date, occasion }) => (
            <li className="rlBthDate__list--item" key={id}>
              {date} - {occasion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

BathingDates.propTypes = {
  data: PropTypes.array,
  heading: PropTypes.string,
  customClass: PropTypes.string
};

export default BathingDates;
